import { useContext } from 'react';

import { Typography } from 'antd';

import { StepThreeFormContext } from '../../../contexts/StepThreeForm';

import { groupByCodeFamily, mergeArrays, newOrderFamilies, PlansValues, setCoverageRow, setFamilyRow, setTitleColumn } from '../../HomeFormByTabClosed/utils/group-coverages-by-code-family';
import { GenericDataFormContext } from '../../../../../../shared';
import { CoveragePlanSelected } from '../../../../../interfaces/listPlansSelected';
import { CoveragePerPlan, RequestCoveragesByPlanActivities } from '../../../../../../../../../../shared/interfaces';

export const useGenerateDataTable = () => {
  const {
    stepThreeHomeQuotationFormCoverages
  } = useContext(StepThreeFormContext);

  const { plansSelected, setPlansSelected, allCoveragesPerPlan } = useContext(GenericDataFormContext);

  if (!plansSelected.length) {
    return { groupedData: {} };
  }

  const deleteColumn = (planId: any) => {
    const fields = stepThreeHomeQuotationFormCoverages.getFieldsValue();
    const fieldNamesToReset = Object.keys(fields).filter((fieldName) =>
      fieldName.startsWith(`aditional-plan-${planId}`)
    );

    stepThreeHomeQuotationFormCoverages.resetFields(fieldNamesToReset);
  
    setPlansSelected((plansSelected as Array<string>).filter((plan) => plan !== String(planId)) as Array<string>);
  }

  let allCoverages: Array<CoveragePerPlan> = [];

  plansSelected.forEach((plan) => {
    const filteredCoverages: { 
      plan: string | RequestCoveragesByPlanActivities, 
      coverages: Array<CoveragePerPlan> 
    } | undefined = allCoveragesPerPlan.find((el) => (el.plan as string) === plan);
    
    if(filteredCoverages?.coverages) {
      allCoverages = mergeArrays(allCoverages, filteredCoverages!.coverages);
    };
  });

  const groupedData = groupByCodeFamily(allCoverages);
  const groupedDataOrdered = newOrderFamilies(groupedData);

  const {columnsDataTitles, columnsDataTitlesSummary} = setTitleColumn(plansSelected.map((plan) => plan as string))

  const rowDataTable: any = [{
    key: 'descCov',
    description: 'Descripción de cobertura',
  }];

  plansSelected.forEach((plan) => {
    rowDataTable[0][`sumaAsegurada-${plan}`] = (
      <Typography.Text strong>
        Suma asegurada
      </Typography.Text>
    );
  });

  for (const property in groupedDataOrdered) {

    const uniqueFamilyDescription = Array.from(
      new Set(groupedData[property].map((cobertura: any) => cobertura.descripcionFamilia))
    );

    const plansAmount = plansSelected.length;

    const familyRow = setFamilyRow(uniqueFamilyDescription, plansAmount) 
    rowDataTable.push(familyRow);

    groupedData[property].forEach((coverage: CoveragePlanSelected) => {
      const plansValues = plansSelected.map((plan) => {
        const filteredCoverages = allCoveragesPerPlan.find((el) => (el.plan as string) === plan)?.coverages;
        const coberturaPlan = filteredCoverages?.find((item: CoveragePlanSelected) => item.codigo === coverage.codigo && item.codigoRiesgo === coverage.codigoRiesgo)

        return {
          planId: plan,
          value: coberturaPlan?.sumaAseguradaPorDefecto,
          coverageType: coberturaPlan?.tipoCobertura,
          codePlan: coberturaPlan?.codigo,
        }
      }) as PlansValues[];
      const coverageRow = setCoverageRow(coverage.descripcionLarga, plansValues, stepThreeHomeQuotationFormCoverages);

      rowDataTable.push(coverageRow);
    })
  }

  return { columnsDataTitles, columnsDataTitlesSummary, rowDataTable, deleteColumn };
};
